var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "batchAdjustment padd30" },
    [
      _c(
        "div",
        [
          _c("div", { staticClass: "box20" }),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { label: "货品名称", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "请输入" },
                          model: {
                            value: scope.row.name,
                            callback: function($$v) {
                              _vm.$set(scope.row, "name", $$v)
                            },
                            expression: "scope.row.name"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c(
                "el-table-column",
                {
                  attrs: { label: "商品图" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.img
                            ? _c("span", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "c_blue pad10_lr cursor",
                                    on: {
                                      click: function($event) {
                                        return _vm.onPreview(scope.row.img)
                                      }
                                    }
                                  },
                                  [_vm._v("预览")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "c_blue pad10_lr cursor",
                                    on: {
                                      click: function($event) {
                                        return _vm.changeImg(
                                          scope.row.img,
                                          scope.$index
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action:
                                            "https://upload-z2.qiniup.com/",
                                          "show-file-list": false,
                                          "on-success": _vm.handleSuccess,
                                          "before-upload": _vm.beforeUpload,
                                          "on-remove": _vm.handleRemove,
                                          data: _vm.postData
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "c_blue pad10_lr cursor"
                                          },
                                          [_vm._v("更换")]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            : _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.changeImg(
                                        scope.row.img,
                                        scope.$index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-demo",
                                      attrs: {
                                        action: "https://upload-z2.qiniup.com/",
                                        "show-file-list": false,
                                        "on-success": _vm.handleSuccess,
                                        "before-upload": _vm.beforeUpload,
                                        "on-remove": _vm.handleRemove,
                                        data: _vm.postData
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "c_blue pad10_lr cursor"
                                        },
                                        [_vm._v("上传图片")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c(
                      "span",
                      { staticClass: "relative cursor table_hint_wrap" },
                      [
                        _c("i", {
                          staticClass: "el-icon-warning-outline gray9"
                        }),
                        _c("span", { staticClass: "table_hint w165" }, [
                          _vm._v("只对商品第一张图进行管理")
                        ])
                      ]
                    ),
                    _c("span", { staticClass: "pad5_l" }, [_vm._v("商品图")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { label: "分类" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: scope.row.sort,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "sort", $$v)
                                },
                                expression: "scope.row.sort"
                              }
                            },
                            _vm._l(_vm.sortList, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c(
                      "span",
                      { staticClass: "relative cursor table_hint_wrap" },
                      [
                        _c("i", {
                          staticClass: "el-icon-warning-outline gray9"
                        }),
                        _c("span", { staticClass: "table_hint w195" }, [
                          _vm._v("请在商品管理-分类管理进行设置")
                        ])
                      ]
                    ),
                    _c("span", { staticClass: "pad5_l" }, [_vm._v("分类")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { label: "价格" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: scope.row.price,
                              callback: function($$v) {
                                _vm.$set(scope.row, "price", $$v)
                              },
                              expression: "scope.row.price"
                            }
                          })
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", [_vm._v("价格")]),
                    _c(
                      "span",
                      { staticClass: "relative cursor table_hint_wrap" },
                      [
                        _c("i", {
                          staticClass: "el-icon-edit-outline pad5_l gray9",
                          on: {
                            click: function($event) {
                              _vm.drawerDialog = true
                            }
                          }
                        }),
                        _c(
                          "span",
                          { staticClass: "table_hint table_hint_price w116" },
                          [_vm._v("点击批量调整价格")]
                        )
                      ]
                    )
                  ])
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "计量单位" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: { filterable: "", placeholder: "请选择" },
                            model: {
                              value: scope.row.unit,
                              callback: function($$v) {
                                _vm.$set(scope.row, "unit", $$v)
                              },
                              expression: "scope.row.unit"
                            }
                          },
                          _vm._l(_vm.sortList, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c(
                "el-table-column",
                {
                  attrs: { label: "库存" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: scope.row.stock,
                              callback: function($$v) {
                                _vm.$set(scope.row, "stock", $$v)
                              },
                              expression: "scope.row.stock"
                            }
                          })
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", [_vm._v("库存")]),
                    _c(
                      "span",
                      { staticClass: "relative cursor table_hint_wrap" },
                      [
                        _c("i", {
                          staticClass: "el-icon-edit-outline pad5_l gray9",
                          on: {
                            click: function($event) {
                              _vm.drawerDialog = true
                            }
                          }
                        }),
                        _c(
                          "span",
                          { staticClass: "table_hint table_hint_price w116" },
                          [_vm._v("点击批量调整库存")]
                        )
                      ]
                    )
                  ])
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "销售单位" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: { filterable: "", placeholder: "请选择" },
                            model: {
                              value: scope.row.marketingUnit,
                              callback: function($$v) {
                                _vm.$set(scope.row, "marketingUnit", $$v)
                              },
                              expression: "scope.row.marketingUnit"
                            }
                          },
                          _vm._l(_vm.sortList, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c(
                "el-table-column",
                {
                  attrs: { label: "换算比例" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: scope.row.conversion,
                              callback: function($$v) {
                                _vm.$set(scope.row, "conversion", $$v)
                              },
                              expression: "scope.row.conversion"
                            }
                          })
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c(
                      "span",
                      { staticClass: "relative cursor table_hint_wrap" },
                      [
                        _c("i", {
                          staticClass: "el-icon-warning-outline gray9"
                        }),
                        _c("span", { staticClass: "table_hint w368" }, [
                          _vm._v(
                            "销售单位与计量单位的换算比例，如：70公斤/头，换算比例为70"
                          )
                        ])
                      ]
                    ),
                    _c("span", { staticClass: "pad5_l" }, [_vm._v("换算比例")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { label: "微信支付" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#13ce66",
                              "inactive-color": "#cccccc"
                            },
                            model: {
                              value: scope.row.wxPay,
                              callback: function($$v) {
                                _vm.$set(scope.row, "wxPay", $$v)
                              },
                              expression: "scope.row.wxPay"
                            }
                          })
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c(
                      "span",
                      { staticClass: "relative cursor table_hint_wrap" },
                      [
                        _c("i", {
                          staticClass: "el-icon-warning-outline gray9"
                        }),
                        _c("span", { staticClass: "table_hint w320" }, [
                          _vm._v(
                            "启用后该商品支持微信支付，您将承担千分之六的手续费"
                          )
                        ])
                      ]
                    ),
                    _c("span", { staticClass: "pad5_l" }, [_vm._v("微信支付")])
                  ])
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "配送范围" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: { filterable: "", placeholder: "请选择" },
                            model: {
                              value: scope.row.delivery,
                              callback: function($$v) {
                                _vm.$set(scope.row, "delivery", $$v)
                              },
                              expression: "scope.row.delivery"
                            }
                          },
                          _vm._l(_vm.sortList, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "运费" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: { filterable: "", placeholder: "请选择" },
                            model: {
                              value: scope.row.freight,
                              callback: function($$v) {
                                _vm.$set(scope.row, "freight", $$v)
                              },
                              expression: "scope.row.freight"
                            }
                          },
                          _vm._l(_vm.sortList, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.showViewer
        ? _c("el-image-viewer", {
            attrs: { "on-close": _vm.closeViewer, "url-list": [_vm.imgViewer] }
          })
        : _vm._e(),
      _c(
        "el-drawer",
        {
          ref: "drawer",
          attrs: {
            direction: "rtl",
            title: _vm.drawerTitle,
            visible: _vm.drawerDialog,
            "custom-class": "demo-drawer"
          },
          on: {
            "update:visible": function($event) {
              _vm.drawerDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "demo-drawer__content" },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.drawerForm } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "调整方案：", "label-width": "120px" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.drawerForm.method,
                            callback: function($$v) {
                              _vm.$set(_vm.drawerForm, "method", $$v)
                            },
                            expression: "drawerForm.method"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("按数值")
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("按比例")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "调整目标：", "label-width": "120px" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.drawerForm.amend,
                            callback: function($$v) {
                              _vm.$set(_vm.drawerForm, "amend", $$v)
                            },
                            expression: "drawerForm.amend"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("增加")
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("降低")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", "label-width": "120px" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.drawerForm.num,
                          callback: function($$v) {
                            _vm.$set(_vm.drawerForm, "num", $$v)
                          },
                          expression: "drawerForm.num"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "demo-drawer_hint" }, [
                _vm.drawerForm.method === 1
                  ? _c("span", [_vm._v("当前所有商品在原价格基础上 增加 100")])
                  : _c("span", [_vm._v("当前所有商品在原价格基础上 增加 10%")])
              ]),
              _c(
                "div",
                { staticClass: "demo-drawer__footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.drawerDialog = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.drawerDialog = false
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }